module.exports = __webpack_public_path__ + "assets/inner-bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/inner-bg.jpg
// module id = 1665
// module chunks = 7